import printComponent from './contact_request_print.component';

let printModule = angular.module('contactRequestPrint', [
])
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/branchManagement.contactRequest');

        $stateProvider
            .state('contactRequestPrint', {
                url: '/print-contact-request-report',
                component: 'contactRequestPrint',
                data: {
                    requireLogin: true,
                    requireACL: 'branch_mgmt_contact_request.all'
                },
            })
    })

    .component('contactRequestPrint', printComponent)

    .name;

export default printModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/contact_request/print/index.js